import type { KnowledgeMatch } from "@frontierx/types";
import { Info } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";

interface AiHelpSourceMaterialProps {
  sourceMaterial: KnowledgeMatch[] | null | undefined;
}

export function AiHelpSourceMaterial({
  sourceMaterial,
}: Readonly<AiHelpSourceMaterialProps>) {
  if (!sourceMaterial || sourceMaterial.length === 0) return null;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Info className="h-4 w-4" />
          View Sources ({sourceMaterial.length})
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Source Material</DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh]">
          <div className="space-y-4">
            {sourceMaterial.map((match, index) => (
              <div key={`item-${index}`} className="rounded-lg border p-4">
                <div className="mb-2 flex items-start justify-between">
                  <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                    {match.metadata?.type === "faq" ? "FAQ" : match.fileName}
                  </span>
                  <span className="text-sm text-gray-500">
                    Score: {Math.round(match.score * 100)}%
                  </span>
                </div>
                <div className="whitespace-pre-wrap text-sm">{match.text}</div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
